export default {
  list: null,
  subTimeout: null,
  message: "",
  success: false,
  sessionId: ""
};
